<template>
  <FrequentlyAskedQuestions class="faq" :title="title" :items="items" />
</template>

<script lang="ts" setup>
import { FrequentlyAskedQuestions, type FaqItem } from '@/features/faq';

defineProps<{
  title: string;
  items: FaqItem[];
}>();
</script>

<style lang="scss" scoped>
.faq {
  margin-top: var(--alias-space-80);

  @include tablet {
    margin-top: var(--alias-space-64);
  }

  @include mobile {
    margin-top: var(--alias-space-48);
  }
}
</style>
